/*
 * The File Uploader is loaded from the CDN (src/index.html), so its types aren't
 * installed. These are the parts of the Plugin API our plugins use (1.29+).
 * https://uploadcare.com/docs/file-uploader/plugins/
 */

/** The fields of an uploader file entry our plugins read. */
export interface UploaderFileEntry {
  internalId: string;
  /** "local" (file picker or paste), "drop-area", "url", "js-api", external source ids… */
  source: string | null;
  file: File | Blob | null;
}

export interface UploaderApi {
  addFileFromUuid(uuid: string, options?: { silent?: boolean; fileName?: string }): unknown;
  removeFileByInternalId(internalId: string): void;
  setCurrentActivity(activity: string, params?: Record<string, unknown>): void;
  setModalState(opened: boolean): void;
  /** Subscribes to an uploader event; returns an unsubscribe function. */
  on(type: string, handler: (entry: UploaderFileEntry) => void): () => void;
}

export interface PluginApi {
  registry: {
    registerSource(source: { id: string; label: string; icon?: string; onSelect: () => void }): void;
    registerActivity(activity: { id: string; render: (host: HTMLElement) => (() => void) | void }): void;
    registerIcon(icon: { name: string; svg: string }): void;
    registerL10n(strings: Record<string, Record<string, string>>): void;
  };
}

export interface UploaderPlugin {
  id: string;
  setup(api: { pluginApi: PluginApi; uploaderApi: UploaderApi }): void | (() => void);
}
